import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Avatar,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Tooltip,
  Divider,
  Button
} from "@mui/material";

// App Icons
import MenuIcon from "@mui/icons-material/Menu";
//---------------- Styles---------------- 
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Sidebar + Logout---------------- 
import Sidebar from "./Sidebar";
import Logout from "./Logout";

//---------------- Styles---------------- 
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//-----------SessionTimeOut---------
//import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";
//-----------Role-------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//----------Income Or Expense-----------
import IncomeExpenseIndex from "./components/pages/IncomeExpense/Index";
import IncomeExpenseCreate from "./components/pages/IncomeExpense/Create";
import IncomeExpenseEdit from "./components/pages/IncomeExpense/Edit";
import IncomeExpenseDetails from "./components/pages/IncomeExpense/Details";
//----------Income Expense Head (Account Head)-----------
import IncomeExpenseHeadIndex from "./components/pages/IncomeExpenseHead/Index";
//----------Patient--------------------
import PatientIndex from "./components/pages/Customer/Index";
//----------Supplier--------------------
import SupplierIndex from "./components/pages/Supplier/Index";
//----------Department Dashboard (includes Questioner)--------------------
import DepartmentDashboard from "./components/pages/Department/DepartmentDashboard";
//------------Doctor----------------------
import DoctorIndex from "./components/pages/Doctor/Index";
import DoctorEntryIndex from "./components/pages/Doctor/DoctorEntryIndex";
import DoctorEntryEdit from "./components/pages/Doctor/DoctorEntryEdit";
import DoctorEntryInfo from "./components/pages/Doctor/DoctorEntryInfo";
//------------Pharmacy----------------------
import PharmacyIndex from "./components/pages/Pharmacy/PharmacyIndex";
import PharmacyDispense from "./components/pages/Pharmacy/PharmacyDispense";
//----------Category--------------------
import CategoryIndex from "./components/pages/Category/Index";
//----------Brand--------------------
import BrandIndex from "./components/pages/Brand/Index";
//----------Item--------------------
import ItemIndex from "./components/pages/Item/Index";
//----------Item Dashboard (Combined)--------------------
import ItemDashboard from "./components/pages/Item/ItemDashboard";
//----------Item Appointment--------------------
import AppointmentCreate from "./components/pages/Appointment/Create";
import AppointmentIndex from "./components/pages/Appointment/Index";
//----------Treatment Dashboard (Combined Category, Treatment, Session)--------------------
import TreatmentDashboard from "./components/pages/Treatment";
//----------Weekly Template--------------------
import WeeklySchedule from "./components/pages/WeeklySchedules/Create";
//----------Doctor Montly Diary--------------------
import DoctorMontlyDiary from "./components/pages/DoctorDiary/Create";
import DoctorEntryCreateIds from "./components/pages/Doctor/DoctorEntryCreateId";


// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: { main: "#1a1f3a" },
    secondary: { main: "#0f1419" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [hoverOpen, setHoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { companyName, roleName, username } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Listen for window resize to detect mobile
  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Header */}
        <AppBar position="fixed" color="primary" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }} style={{ height: '55px' }}>
          <Toolbar>
            {/* Hide menu icon on mobile since we use bottom nav */}
            {!isMobile && (
              <IconButton color="inherit" onClick={() => setSidebarOpen(!sidebarOpen)}>
                <MenuIcon />
              </IconButton>
            )}

            <Typography
              variant="h6"
              sx={{ flexGrow: 1, ml: isMobile ? 0 : 2, fontWeight: "bold", textTransform: "uppercase" }}
            >
              <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                <span style={{ fontFamily: 'Verdana, sans-serif', fontSize: '14px' }}>{companyName}</span>
              </Link>
            </Typography>

            <div className="white-icon" style={{ display: 'flex', alignItems: 'center', marginTop: '-5px', }} >
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }} >
                <span style={{ fontFamily: 'monospace' }}>{username}</span> <Logout />
              </div>
            </div>
          </Toolbar>
        </AppBar>

        {/* Sidebar - Only show on desktop */}
        {username !== "Counter" && !isMobile && (
          <Box
            onMouseEnter={() => setHoverOpen(true)}
            onMouseLeave={() => setHoverOpen(false)}
          >
            <Sidebar open={sidebarOpen || hoverOpen} roleName={roleName} />
          </Box>
        )}

        {/* Mobile Bottom Navigation */}
        {username !== "Counter" && isMobile && (
          <Sidebar open={false} roleName={roleName} />
        )}

        {/* Content */}
        <Box
          sx={{
            // On mobile: no left margin, add bottom padding for bottom nav
            // On desktop: normal sidebar margin
            ml: isMobile ? 0 : (sidebarOpen || hoverOpen ? "240px" : "60px"),
            pt: 10,
            pb: isMobile ? '80px' : 0, // Add padding for bottom nav on mobile
            transition: "0.3s",
          }}
        >
          <Container maxWidth="xl" sx={{ mt: 2 }}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Item */}
              {/* <Route path="/ItemIndex" component={ItemIndex} />
              <Route path="/ItemCreate" component={ItemCreate} />
              <Route path="/ItemEdit/:id" component={ItemEdit} /> */}

              {/* Role */}
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />

              {/* User */}
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/PasswordChange" component={PasswordChange} />

              {/* Income Or Expense */}
              <Route path="/IncomeExpenseIndex" component={IncomeExpenseIndex} />
              <Route path="/IncomeExpenseCreate" component={IncomeExpenseCreate} />
              <Route path="/IncomeExpenseEdit/:id" component={IncomeExpenseEdit} />
              <Route path="/IncomeExpenseDetails/:id" component={IncomeExpenseDetails} />

              {/* Income Expense Head (Account Head) */}
              <Route path="/IncomeExpenseHeadIndex" component={IncomeExpenseHeadIndex} />             

              {/* Payment And Receipt */}
              <Route path="/CompanyEdit" component={CompanyEdit} />
              {/* Customer */}
              <Route path="/PatientIndex" component={PatientIndex} />
              {/* Supplier */}
              <Route path="/SupplierIndex" component={SupplierIndex} />
              {/* Department */}
              {/* Department Dashboard (includes Questioner) */}
              <Route path="/DepartmentIndex" component={DepartmentDashboard} />
              <Route path="/QuestionierIndex" component={DepartmentDashboard} />
              {/* Doctor */}
              <Route path="/DoctorIndex" component={DoctorIndex} />
              <Route path="/DoctorEntryIndex" component={DoctorEntryIndex} />              
              <Route path="/DoctorEntryEdit/:id" component={DoctorEntryEdit} />
              <Route path="/DoctorEntryInfo/:id?" component={DoctorEntryInfo} />
              <Route path="/DoctorEntryCreateIds/:id" component={DoctorEntryCreateIds} />

              {/* Category */}
              <Route path="/CategoryIndex" component={CategoryIndex} />

              {/* Brand */}
              <Route path="/BrandIndex" component={BrandIndex} />

              {/* Item */}
              <Route path="/ItemIndex" component={ItemIndex} />

              {/* Item Dashboard (Combined Category, Brand, Item) */}
              <Route path="/ItemDashboard" component={ItemDashboard} />

              {/* Appointment */}
              <Route path="/AppointmentCreate" component={AppointmentCreate} />
              <Route path="/AppointmentIndex" component={AppointmentIndex} />

              {/* Treatment Dashboard (Combined Category, Treatment, Session) */}
              <Route path="/TCategoryIndex" component={TreatmentDashboard} />
              <Route path="/TreatmentsIndex" component={TreatmentDashboard} />
              <Route path="/TSessionIndex" component={TreatmentDashboard} />
              <Route path="/TreatmentDashboard" component={TreatmentDashboard} />

              {/* Weekly Schedule */}
              <Route path="/WeeklySchedule" component={WeeklySchedule} />
              <Route path="/DoctorMontlyDiary" component={DoctorMontlyDiary} />

              {/* Pharmacy */}
              <Route path="/PharmacyIndex" component={PharmacyIndex} />
              <Route path="/PharmacyDispense/:id" component={PharmacyDispense} />

            </Switch>
          </Container>
        </Box>
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
